/**
 * The ONE responsive breakpoint of the design system: the generated theme
 * switches its mobile/desktop token values at 1024px (`theme.css`), and every
 * DS component's `@media (min-width: 1024px)` follows it. JS that needs the
 * same split (sheet vs popup, swipe vs rail, frozen svh…) reads it from here
 * instead of repeating the string.
 */
export const DESKTOP_MIN = 1024;
export const MOBILE_QUERY = `(max-width: ${DESKTOP_MIN - 1}px)`;
export const DESKTOP_QUERY = `(min-width: ${DESKTOP_MIN}px)`;

/** True below the desktop breakpoint; false where matchMedia is unavailable (SSR, jsdom) */
export const isMobileViewport = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(MOBILE_QUERY).matches;
